import React from 'react';

// Avatar originali del modello. Autorizzazione all’uso per Tricotin con Amore da verificare.
const avatars = [{
  src: 'https://cdn.magicpatterns.com/uploads/otdxAPsiLM4NSAwvjvizYg/image.png',
  position: '60% 35%'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qjU76Prc33qP47eZjvS6FD/image.png',
  position: '40% 55%'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ck5pwprDEj6CFg6roxn2QJ/image.png',
  position: '50% 30%'
}];

/** Avatar decorativi della capsula di valutazione. */
export function HeroAvatars() {
  return <span aria-hidden="true" className="flex shrink-0 -space-x-2" data-id="element-114" data-mp="w8r74na605px">
      {avatars.map(a => <img key={a.src} src={a.src} alt="" decoding="async" className="h-8 w-8 rounded-full object-cover ring-2 ring-cream" style={{
      objectPosition: a.position
    }} data-id="element-115" data-mp="1a7z5xf2f1btl" />)}
    </span>;
}